import { NodeTemplateTaintWithOptionalEffect } from '@cast/types';

import { CustomLabelsModel } from 'features/cluster/autoscaler/node-selection-templates/types';

import { EnhancedEdgeLocation } from '../../types';

export enum ProvisionNodesDrawerSlides {
  EdgeLocation = 'edgeLocation',
  Configuration = 'configuration',
  Setup = 'setup',
}

export type ProvisionNodesCustomConfigurationFormValues = {
  shouldTaint: boolean;
  shouldUseCustomLabels: boolean;
  _customTaints: NodeTemplateTaintWithOptionalEffect[];
  _customLabels: CustomLabelsModel[];
  replicas: number | undefined;
  partitionSize: string | undefined;
};

export type ProvisionNodesCloudConfigurationFormValues = {
  name: string | undefined;
  instanceType: string | undefined;
  availabilityZone: string | undefined;
  edgeConfigurationId: string | undefined;
  resourceOffering: 'on-demand' | 'spot';
  gpuType: string | undefined;
  gpuCount: number | undefined;
  replicas: number | undefined;
  partitionSize: string | undefined;
  bootDiskGib: number | undefined;
  shouldTaint: boolean;
  shouldUseCustomLabels: boolean;
  _customTaints: NodeTemplateTaintWithOptionalEffect[];
  _customLabels: CustomLabelsModel[];
  deleteProtection: boolean;
};

export type ProvisionNodesDrawerContextValue = {
  clusterId: string | undefined;
  edgeLocation: EnhancedEdgeLocation | undefined;
  hasEdgeLocationPredefined: boolean;
  setEdgeLocation: (edgeLocation: EnhancedEdgeLocation | undefined) => void;
  customConfigValue: ProvisionNodesCustomConfigurationFormValues | undefined;
  cloudConfigValue: ProvisionNodesCloudConfigurationFormValues | undefined;
  setCustomConfigValue: (
    value: ProvisionNodesCustomConfigurationFormValues
  ) => void;
  setCloudConfigValue: (
    value: ProvisionNodesCloudConfigurationFormValues
  ) => void;
};
